import { render, staticRenderFns } from "./KeepingAttributes.vue?vue&type=template&id=9ef71ed6&scoped=true&"
import script from "./KeepingAttributes.vue?vue&type=script&lang=js&"
export * from "./KeepingAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef71ed6",
  null
  
)

export default component.exports